/**
 * Comprueba si el country de compañía (POST /master) es España (ISO-3 `esp`).
 */
export function isSpainCompanyCountry(country?: string | null): boolean {
	return typeof country === 'string' && country.toLowerCase() === 'esp';
}

/**
 * Valor del toggle Schengen desde config OCR (alta/edición).
 * Acepta `is_schengen_unlimited` (canónico) o typo legacy `is_schengen_limited`.
 */
export function resolveOcrSchengenUnlimited(config?: {
	is_schengen_unlimited?: boolean;
	is_schengen_limited?: boolean;
} | null): boolean {
	if (!config) {
		return false;
	}
	if (typeof config.is_schengen_unlimited === 'boolean') {
		return config.is_schengen_unlimited;
	}
	if (typeof config.is_schengen_limited === 'boolean') {
		return config.is_schengen_limited;
	}
	return false;
}
